import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { DsSpecialDevicesIP, MultiOptDetails_2DS, SaveEventType, SaveStatusObj, SOModule, UserType, ValidationItem, ValidationSummary } from '../../../../shared/misc-classes';
import { DataService } from '../../../../shared/dataservice.service';
import { ValidationDialog } from '../../../../dialogs/validation-dialog/validation-dialog';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';


@Component({
  selector: 'ds-special-devices',
  templateUrl: './ds-special-devices.component.html',
  styleUrls: ['./ds-special-devices.component.css']
})
export class DsSpecialDevicesComponent implements OnInit, OnChanges {

  @Input() dsSpecialDevicesObj: DsSpecialDevicesIP;
  @Input() soLockObtained: boolean;
  @Input() accessLevel: Array<UserType>;
  @Output() updateDatasheet: EventEmitter<SaveStatusObj> = new EventEmitter();

  disableForm: boolean = false;
  inputDisableMessage: string = 'This form is not yet enabled';
  readonlyAccess: boolean = false;
  Hvr: any = {};
  hasAccessEE: boolean = false;
  hasAccessME: boolean = false;
  hasAccessPM: boolean = false;
  lockFields: boolean = false; // After HOM lock

  constructor(public _dataService: DataService, public dialog: MatDialog) { }

  ngOnInit(): void {
  }
  ngOnChanges(): void {
    this.disableForm = true;
    if (this.soLockObtained == false) {
      this.inputDisableMessage = "You can't Edit";
    }
    else if (this.accessLevel.includes(this._dataService.userType) == false) {
      this.inputDisableMessage = "You don't have EDIT ACCESS.";
    }
    else {
      this.disableForm = false;
      // this.checkUserEnabled();
    }
    if (this._dataService.hasReadOnlyAccess) {
      this.readonlyAccess = true;
    }
    this.hasAccessEE = this._dataService.userType === (UserType.ELECTRICAL_ENGINEERING) || this._dataService.userType === (UserType.MARKETING) || this._dataService.userType === (UserType.SUPER_ADMIN);
    this.hasAccessME = this._dataService.userType === (UserType.MECHANICAL_ENGINEERING) || this._dataService.userType === (UserType.MARKETING) || this._dataService.userType === (UserType.SUPER_ADMIN);
    this.hasAccessPM = this._dataService.userType === (UserType.PROJECT_MANAGEMENT) || this._dataService.userType === (UserType.MARKETING) || this._dataService.userType === (UserType.SUPER_ADMIN);
    if (!this.dsSpecialDevicesObj.parentSORef.isDatasheetSubOrderEnabled) {
      this.lockFields = false;
    }
    else {
      this.lockFields = true;
    }

  }

  filterTMS() {
    if (!this.dsSpecialDevicesObj.isSdTMSApplicable) {
      this.dsSpecialDevicesObj.sdTMSSensorType = ""; // Not Applicable
      this.dsSpecialDevicesObj.sdTMSComm = ""; // Not Applicable
    }
    else {
      this.dsSpecialDevicesObj.sdTMSComm = "001"; // By Default
    }
  }
  getTransducerRowSpan(): number {
    let _maxRows = 
      this.dsSpecialDevicesObj.sdCurrTransducer.length +
      this.dsSpecialDevicesObj.sdVoltTransducer.length +
      this.dsSpecialDevicesObj.sdPowerTransducer.length +
      this.dsSpecialDevicesObj.sdMultiFuncTransducer.length
    
      return _maxRows > 0 ? _maxRows + 5 : 5;
  }
  addNewTempScannerBlock() {
    this.dsSpecialDevicesObj.addSdTempScannerDS(new MultiOptDetails_2DS("", ""));
  }
  removeTempScannerBlock(_tsDS: MultiOptDetails_2DS) {
    if (_tsDS) {
      this.dsSpecialDevicesObj.removeSdTempScannerDS(_tsDS);
    }
  }

  addNewCurrTransducerBlock() {
    this.dsSpecialDevicesObj.addSdCurrTransducerDS(new MultiOptDetails_2DS("", ""));
  }
  removeCurrTransducerBlock(_ctDS: MultiOptDetails_2DS) {
    if (_ctDS) {
      this.dsSpecialDevicesObj.removeSdCurrTransducerDS(_ctDS);
    }
  }

  addNewVoltTransducerBlock() {
    this.dsSpecialDevicesObj.addSdVoltTransducerDS(new MultiOptDetails_2DS("", ""));
  }
  removeVoltTransducerBlock(_vtDS: MultiOptDetails_2DS) {
    if (_vtDS) {
      this.dsSpecialDevicesObj.removeSdVoltTransducerDS(_vtDS);
    }
  }

  addNewPowerTransducerBlock() {
    this.dsSpecialDevicesObj.addSdPowerTransducerDS(new MultiOptDetails_2DS("", ""));
  }
  removePowerTransducerBlock(_ptDS: MultiOptDetails_2DS) {
    if (_ptDS) {
      this.dsSpecialDevicesObj.removeSdPowerTransducerDS(_ptDS);
    }
  }

  addNewMultiFuncTransducerBlock() {
    this.dsSpecialDevicesObj.addSdMultiFuncTransducerDS(new MultiOptDetails_2DS("", ""));
  }
  removeMultiFuncTransducerBlock(_mftDS: MultiOptDetails_2DS) {
    if (_mftDS) {
      this.dsSpecialDevicesObj.removeSdMultiFuncTransducerDS(_mftDS);
    }
  }

 sectionNoteChangePM(_event: any) {
    this.dsSpecialDevicesObj.sectionNotePM = _event.target.value;
  }
  sectionNoteChangeEE(_event: any) {
    this.dsSpecialDevicesObj.sectionNoteEE = _event.target.value;
  }
  sectionNoteChangeME(_event: any) {
    this.dsSpecialDevicesObj.sectionNoteME = _event.target.value;
  }

  saveDS(_submitToNextSection: boolean) {
    if (this.updateDatasheet) {
      this.updateDatasheet.emit(new SaveStatusObj(SOModule.Marketing,
        (_submitToNextSection == true ? SaveEventType.Submit_To_Next : SaveEventType.Save_Data)));
    }
  }
  reloadData() {
    if (this.updateDatasheet) {
      this.updateDatasheet.emit(new SaveStatusObj(SOModule.Marketing, SaveEventType.Reload_Data));
    }
  }

  showSoValidation() {
    let _validList: Array<ValidationItem> = [];

    if (this.hasAccessEE) {
      _validList.push(
        new ValidationItem("Voltage Indicator", !!this.dsSpecialDevicesObj.sdVoltIndicator, " required to save Datasheet."),
        new ValidationItem("Temperature Monitoring System", !!this.dsSpecialDevicesObj.sdTMS, " required to save Datasheet.")
      );
      if (this.dsSpecialDevicesObj.isSdTMSApplicable) {
        _validList.push(
          new ValidationItem("TMS Sensor Type", !!this.dsSpecialDevicesObj.sdTMSSensorType, " required to save Datasheet."),
          new ValidationItem("TMS Communication", !!this.dsSpecialDevicesObj.sdTMSComm, " required to save Datasheet.")
        );
      }
      _validList.push(
        new ValidationItem("Humidity Monitoring", !!this.dsSpecialDevicesObj.sdHumidityMonitoring, " required to save Datasheet.")
      );
      if (this.dsSpecialDevicesObj.isSdHumidityMonitoringMkPhlApplicable) {
        _validList.push(new ValidationItem("Humidity Monitoring Make/PhL", !!this.dsSpecialDevicesObj.sdHumidityMonitoringMkPhl, " required to save Datasheet."));
      }
      _validList.push(new ValidationItem("Relay Test Terminal Block", !!this.dsSpecialDevicesObj.sdRTB, " required to save Datasheet."));
      _validList.push(new ValidationItem("Test Terminal Block", !!this.dsSpecialDevicesObj.sdTTB, " required to save Datasheet."));
      _validList.push(new ValidationItem("Test Plug", !!this.dsSpecialDevicesObj.sdTestPlug, " required to save Datasheet."));
      _validList.push(new ValidationItem("Shutter Lifiting Trolley", !!this.dsSpecialDevicesObj.sdSLT, " required to save Datasheet."));
      _validList.push(new ValidationItem("Media Converter", !!this.dsSpecialDevicesObj.mediaConv, " required to save Datasheet."));
      _validList.push(new ValidationItem("EE Note", !!this.dsSpecialDevicesObj.sectionNoteEE, " required to save Datasheet."));
    }
    if (this.hasAccessME) {
      if (this.dsSpecialDevicesObj.isSdVoltIndicatorApplicable) {
        _validList.push(new ValidationItem("Mounting", !!this.dsSpecialDevicesObj.sdMounting, " required to save Datasheet."));
      }
      _validList.push(
        new ValidationItem("IR Window", !!this.dsSpecialDevicesObj.sdIRWindow, " required to save Datasheet."),
        new ValidationItem("Inspection Window", !!this.dsSpecialDevicesObj.sdInspecWindow, " required to save Datasheet."),
        new ValidationItem("ME Note", !!this.dsSpecialDevicesObj.sectionNoteME, " required to save Datasheet.")
      );
    }
    if (this.hasAccessPM) {
      _validList.push(new ValidationItem("PM Note", !!this.dsSpecialDevicesObj.sectionNotePM, " required to save Datasheet."));
    }

    let vSummaryObj: ValidationSummary = new ValidationSummary("Validation Summary.", _validList);
    this.dialog.open(ValidationDialog, { width: '50%', data: vSummaryObj });
  }

  saveSOValidation(): boolean {
    if (this.hasAccessEE) {
      if (!this.dsSpecialDevicesObj.sdVoltIndicator || !this.dsSpecialDevicesObj.sdTMS ||
        !this.dsSpecialDevicesObj.sdHumidityMonitoring || !this.dsSpecialDevicesObj.sectionNoteEE) {
        return false;
      }
      if (this.dsSpecialDevicesObj.isSdTMSApplicable) {
        if (!this.dsSpecialDevicesObj.sdTMSSensorType || !this.dsSpecialDevicesObj.sdTMSComm) return false;
      }
      if (this.dsSpecialDevicesObj.isSdHumidityMonitoringMkPhlApplicable && !this.dsSpecialDevicesObj.sdHumidityMonitoringMkPhl) return false;
      // for (let ts of this.dsSpecialDevicesObj.sdTempScanner) {
      //   if (!ts.type1 || !ts.type2) return false;
      // }
      // for (let ct of this.dsSpecialDevicesObj.sdCurrTransducer) {
      //   if (!ct.type1 || !ct.type2) return false;
      // }
    }
    if (this.hasAccessME) {
      if (this.dsSpecialDevicesObj.isSdVoltIndicatorApplicable && !this.dsSpecialDevicesObj.sdMounting) return false;
      if (!this.dsSpecialDevicesObj.sdIRWindow || !this.dsSpecialDevicesObj.sdInspecWindow ||
        !this.dsSpecialDevicesObj.sectionNoteME) {
        return false;
      }
    }
    if (this.hasAccessPM) {
      if (!this.dsSpecialDevicesObj.sectionNotePM) return false;
    }
    return true;
  }
}

